var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_5982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.6665V9.99984L11.6667 11.6665",
    stroke: "#D4D4D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5415 9.16672C2.72825 7.33344 3.58339 5.63307 4.94378 4.39003C6.30417 3.14699 8.07458 2.44829 9.91724 2.42725C11.7599 2.4062 13.5458 3.06428 14.9342 4.27592C16.3227 5.48756 17.2164 7.16796 17.445 8.9965C17.6735 10.825 17.2209 12.6737 16.1735 14.1899C15.126 15.706 13.557 16.7834 11.7659 17.2166C9.97477 17.6498 8.08685 17.4084 6.46233 16.5384C4.83782 15.6685 3.59044 14.231 2.95817 12.5001M2.5415 16.6667V12.5001H6.70817",
    stroke: "#D4D4D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_5982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.346edb88e5e582241fb0fa1f2bf9ee69.svg";
export { ForwardRef as ReactComponent };